import { EditorState, generateName } from "@common/Common";
import { guid } from "@common/Guid";
import { CurrencyDenomination, TimeFrameGranularity } from "@common/types";

export class ProjectPlanTemplateEditorViewModel
{
    state: EditorState = EditorState.Closed;

    data: ProjectPlanTemplateData | null = null;

    get opened(): boolean { return this.state !== EditorState.Closed; }

    showCreator()
    {
        if (this.state !== EditorState.Closed) return;

        this.data = {
            Id: guid(),
            Name: generateName("Template"),
            Description: null,
            DurationInMonths: 60,
            Granularity: TimeFrameGranularity.Yearly,
            Denomination: CurrencyDenomination.Million,
        }

        this.state = EditorState.Creator;
    }

    showEditor(t: ProjectPlanTemplateData)
    {
        if (this.state !== EditorState.Closed) return;

        this.data = {
            Id: t.Id,
            Name: t.Name,
            Description: t.Description,
            DurationInMonths: t.DurationInMonths,
            Granularity: t.Granularity,
            Denomination: t.Denomination,
        }

        this.state = EditorState.Editor;
    }

    close()
    {
        this.state = EditorState.Closed;
        this.data = null;
    }
}

export class ProjectPlanTemplateData
{
    Id: string | null = null;
    Name: string | null = null;
    Description: string | null = null;
    DurationInMonths: number | null = null;
    Granularity: string | null = null;
    Denomination: string | null = null;
}




